<template>
  <div :class="b([direction])">
    <div v-if="title || description" :class="b('status')">
      <div v-if="icon || $slots.icon" :class="b('icon')">
        <slot name="icon">
          <icon :name="icon" :class="iconClass" />
        </slot>
      </div>
      <div :class="b('message')">
        <div :class="b('title')" v-text="title" />
        <div :class="b('desc')" class="om-ellipsis" v-text="description" />
      </div>
      <slot name="message-extra" />
    </div>
    <div :class="b('items', { alone: !title && !description })">
      <slot />
    </div>
  </div>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'step-bar',

  props: {
    icon: String,
    title: String,
    active: Number,
    iconClass: String,
    description: String,
    direction: {
      type: String,
      default: 'horizontal'
    },
    activeColor: {
      type: String,
      default: '#06bf04'
    }
  },

  data() {
    return {
      steps: []
    };
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/step-bar/index.vue